var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceSheetReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 48,
    rx: 5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 10.5V38.0625H46.875V10.5H13.125ZM44.625 35.8125H15.375V12.75H44.625V35.8125Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 15.5625H24.375V17.8125H18.1875V15.5625Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 20.625H24.375V22.875H18.1875V20.625Z",
    fill: "#828282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 25.6875H24.375V27.9375H18.1875V25.6875Z",
    fill: "#828282"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 30.75H24.375V33H18.1875V30.75Z",
    fill: "#828282"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 15.5625H41.8125V17.8125H32.25V15.5625Z",
    fill: "#828282"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 20.625H41.8125V22.875H32.25V20.625Z",
    fill: "#828282"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 25.6875H41.8125V27.9375H32.25V25.6875Z",
    fill: "#828282"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 30.75H41.8125V33H32.25V30.75Z",
    fill: "#828282"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 15.5625H29.4375V17.8125H27.1875V15.5625Z",
    fill: "#828282"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 20.625H29.4375V22.875H27.1875V20.625Z",
    fill: "#828282"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 25.6875H29.4375V27.9375H27.1875V25.6875Z",
    fill: "#828282"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 30.75H29.4375V33H27.1875V30.75Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceSheetReport);
export default __webpack_public_path__ + "static/media/balance-sheet-report.64c60a3761b3ab57bd31fc9b8d9b02cd.svg";
export { ForwardRef as ReactComponent };